import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse>;

const deleteQuestionChoiceAsset = (
    formId: string,
    sectionId: string,
    questionId: string,
    choiceId: string,
): ReturnType => {
    return Request.delete(
        `/data/forms/${formId}/sections/${sectionId}/questions/${questionId}/choices/${choiceId}/asset`,
    );
};

export default deleteQuestionChoiceAsset;
